import axios from 'src/store/vue-axios/axios.js'

export default class Services {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // SUPPORT -> /services/support/*
  static releaseNotesUrl = () => '/services/support/releases'

  // FAQ -> /services/support/faq*
  static faqUrl = () => '/services/support/faq'
  static faqSearchUrl = (searchVal) => `/services/support/faq?search=${searchVal}`
  static faqCategoryUrl = (categoryId) => `/services/support/faq?category=${categoryId}`
  static faqCategorySearchUrl = (categoryId, searchVal) => `/services/support/faq?category=${categoryId}&search=${searchVal}`
  static faqArticleUrl = (articleId) => `/services/support/faq/article/${articleId}`
  static faqArticleVoteUrl = (articleId, degree) => `/services/support/faq/article/${articleId}/${degree}vote`

  // FEEDBACK -> /services/support/feedback*
  static feedbackUrl = () => '/services/support/feedback'
  static feedbackNoEmailUrl = () => '/services/support/feedback?no-email=true'

  // FEEDBACK-TIMETABLE -> /services/support/feedback-timetable*
  static feedbackTimetableUrl = () => '/services/support/feedback-timetable'

  // ANNOUNCEMENTS -> /services/support/announcements*
  static announcementLimitedUrl = () => '/services/support/announcements?limit=3'
  static announcementArticleUrl = (articleId) => `/services/support/announcements/${articleId} `

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // SUPPORT -> /services/support/*

  // FAQ -> /services/support/faq*
  static async getFaqSearch (searchVal) {
    return axios.get(this.faqSearchUrl(searchVal))
  }

  static async getFaqCategory (categoryId) {
    return axios.get(this.faqCategoryUrl(categoryId))
  }

  static async getFaqCategorySearch (categoryId, searchVal) {
    return axios.get(this.faqCategorySearchUrl(categoryId, searchVal))
  }

  static async getFaq () {
    return axios.get(this.faqUrl())
  }

  static async getFaqArticle (articleId) {
    return axios.get(this.faqArticleUrl(articleId))
  }

  static async putFaqArticleVote (articleId, degree) {
    return axios.put(this.faqArticleVoteUrl(articleId, degree))
  }

  // FEEDBACK -> /services/support/feedback*
  static async postFeedback (payload, config) {
    return axios.post(this.feedbackUrl(), payload, config)
  }

  static async postFeedbackNoEmail (payload) {
    return axios.post(this.feedbackNoEmailUrl(), payload)
  }

  // FEEDBACK-TIMETABLE -> /services/support/feedback-timetable*
  static async postFeedbackTimetable (payload, config) {
    return axios.post(this.feedbackTimetableUrl(), payload, config)
  }

  // ANNOUNCEMENTS -> /services/support/announcements*
  static async getAnnouncementLimited () {
    return axios.get(this.announcementLimitedUrl())
  }

  static async getAnnouncementArticle (articleId) {
    return axios.get(this.announcementArticleUrl(articleId))
  }
}
